// extracted by mini-css-extract-plugin
export default {"CardAuth":"AuthWrapper_CardAuth__OpwX+","ButtonMicroWrapper":"AuthWrapper_ButtonMicroWrapper__c5cWz","Button__exit":"AuthWrapper_Button__exit__8c0-1"};